import React, { useState, useRef, useEffect } from 'react';

import AOS from 'aos';
import 'aos/dist/aos.css';
import { LazyLoadComponent } from 'react-lazy-load-image-component';

import PromotionBanner from '../../components/promotion_banner/promotion_banner';
import Header from '../../components/header/header';
import TopButton from '../../components/fixed_btns/fixed_btns';

import NumCounter from '../../components/num_counter/num_counter';
import StepSlide from '../../components/step_slide/step_slide';
import CaseSlide from '../../components/case_slide/case_slide';
import LogoSlide from '../../components/logo_slide/logo_slide';
import SolutionItem from '../../components/solution_item/solution_item';
import ConnectSlide from '../../components/connect_slide/connect_slide';
import QnaList from '../../components/qna_list/qna_list';

import AskFooter from '../../components/ask_footer/ask_footer';
import Footer from '../../components/footer/footer';

import { solutions } from './data';
import { faqList } from '../../data/faq';
import { cases } from '../../data/main';

//import { onKakaoClick, clickAlimtalk } from '../../common/sendLog';
import styles from './main.module.css';
import ModalPortal from '../../components/modal_portal/modal_portal';
import { useCookies } from 'react-cookie';
import PromoPopup from '../../components/promo_popup/promo_popup';

const Main = ({ preFetch }) => {
  const [popupCookie, setPopupCookie] = useCookies(['main_popup', true]);
  const [popup, setPopup] = useState(
    popupCookie.main_popup === 'false' ? false : true
  );
  const goBelowRef = useRef(null);
  const [caseIndex, setCaseIndex] = useState(1);

  const closePopup = () => {
    setPopup(false);
  };

  const noShowTodayPopup = () => {
    setPopupCookie('main_popup', false, {
      path: '/',
      maxAge: 1 * 24 * 60 * 60,
      sameSite: 'LAX',
    });
    closePopup();
  };

  const qnaList = faqList.filter((faq) =>
    [1, 3, 6, 8, 9, 11].includes(faq.faqId)
  );

  const [promoOpen, setPromoOpen] = useState(false);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    //setLoading(true);
  }, []);

  return (
    <div className={styles.container}>
      <PromotionBanner url={'https://sales.unospay.com'} />
      {popup && (
        <ModalPortal>
          <div className={styles.popup}>
            <div className={styles.popupContainer}>
              <div className={styles.popupContents}>
                <h2 className={styles.popupTitle}>
                  우노스페이와 오더퀸이 하나가 되어 <br />
                  <strong>비버 매장연구소로 새롭게 출발합니다.</strong>
                </h2>
                <p>
                  안녕하세요 우노스페이 입니다. <br />
                  우노스페이와 오더퀸이 하나가 되어 “비버 매장연구소”로 새롭게
                  출발합니다.
                  <br /> 발전을 위한 새로운 시작이며 보다 나은 서비스를 제공하기
                  위하여 끊임없이 노력할 것을 약속드리겠습니다. 리브랜딩으로
                  인한 고객분들의 불편함이 없도록 최선을 다할 것이며 기존에
                  사용하던 계정 정보는 유지, 이전됩니다. 금번 리브랜딩으로
                  우노스페이의 새 이름인 “비버 매장연구소”와 함께, 더 나은
                  서비스와 더욱 발전된 비전을 가지고 고객분들과 함께
                  나아가겠습니다. 감사합니다.
                  <br />
                  <a href='https://www.beaverstorelab.com/'>
                    <button className={styles.linkBtn}>
                      비버매장연구소 구경하기
                    </button>
                  </a>
                </p>
              </div>
            </div>
            <div className={styles.popupBtns}>
              <button onClick={noShowTodayPopup} className={styles.popupBtn}>
                오늘은 그만 보기
              </button>
              <button onClick={closePopup} className={styles.blueBtn}>
                닫기
              </button>
            </div>
          </div>
        </ModalPortal>
      )}

      <div className={styles.topSection}>
        <div className={styles.headerBox}>
          <Header isTrans preFetch={preFetch} />
        </div>

        <div className={`${styles.maxWidth} ${styles.topContent}`}>
          <div className={styles.textBox}>
            <h1>
              성공한 프랜차이즈가 선택한 <br /> 똑똑한 주문방법
            </h1>
            <p>
              주문, 결제, 적립, 관리 <br />
              매장 운영에 필요한 모든 서비스를 제공합니다.
            </p>
            {/* <div className={styles.askBtns}></div> */}
          </div>
          <div className={styles.videoBox}>
            <video
              className={styles.video}
              autoPlay
              muted
              loop
              playsInline
              src={process.env.PUBLIC_URL + '/imgs/main/intro_new.mp4'}
              poster={
                process.env.PUBLIC_URL + '/imgs/main/intro_poster_new.png'
              }
            />
          </div>
        </div>
      </div>

      <section className={styles.unosSection} ref={goBelowRef}>
        <div className={styles.maxWidth} data-aos='fade-up'>
          <h1 data-aos='fade-up' className={styles.blackTitle}>
            우노스는 <span className={styles.textBlue}> 100여 개의 브랜드</span>
            와 <br />
            <span className={styles.textBlue}>4,000여 개의 가맹점</span>과
            함께합니다.
          </h1>
        </div>

        <div
          className={[styles.flexAround, styles.summaryWrapper].join(' ')}
          data-aos='fade-up'
          data-aos-offset='300'
          data-aos-duration='1000'
        >
          <div className={styles.summaryBox}>
            <div className={styles.summaryIcon}>
              <img
                src={process.env.PUBLIC_URL + '/imgs/main/icon/count.png'}
                alt='count'
              />
            </div>

            <span className={styles.description}>제품 누적판매수</span>
            <h4>
              <span className={styles.countNum}>
                <NumCounter start={3000} end={4500} duration={4} />
              </span>
              + 대
            </h4>
          </div>

          <div className={styles.summaryBox}>
            <div className={styles.summaryIcon}>
              <img
                src={process.env.PUBLIC_URL + '/imgs/main/icon/customer.png'}
                alt='count'
              />
            </div>
            <span className={styles.description}>매 월 이용고객</span>
            <h4>
              <span className={styles.countNum}>
                <NumCounter start={3000000} end={3742421} duration={4} />
              </span>
              + 명
            </h4>
          </div>

          <div className={styles.summaryBox}>
            <div className={styles.summaryIcon}>
              <img
                src={process.env.PUBLIC_URL + '/imgs/main/icon/brand.png'}
                alt='count'
              />
            </div>
            <span className={styles.description}>가맹점 일 평균 거래 대금</span>
            <h4>
              <span className={styles.countNum}>
                <NumCounter start={900000000} end={976409848} />
              </span>
              + 원
            </h4>
          </div>
        </div>

        <span className={styles.outDescription}>2023.03 기준</span>

        <div className={styles.logoSlideContainer}>
          <LogoSlide />
        </div>
      </section>

      {/* step*/}
      <section className={styles.stepSection}>
        <div className={styles.maxWidth}>
          <StepSlide />
        </div>
      </section>

      <section className={styles.caseSection}>
        <div data-aos='fade-up' className={styles.caseHeader}>
          <h1 className={[styles.blackTitle, styles.caseTitle].join(' ')}>
            다양한 업종에 어울리는
            <br /> 우노스 결제 솔루션
          </h1>
          <div className={styles.casePages}>
            {cases &&
              cases.map((caseItem, index) => {
                return (
                  <span
                    key={index}
                    onClick={() => setCaseIndex(caseItem.id)}
                    className={
                      caseItem.id === caseIndex
                        ? [styles.casePage, styles.activeCase].join(' ')
                        : styles.casePage
                    }
                  >
                    {caseItem.type}
                  </span>
                );
              })}
          </div>
        </div>

        <div data-aos='fade-up' className={styles.caseCardBox}>
          <CaseSlide caseIndex={caseIndex} setCaseIndex={setCaseIndex} />
        </div>
      </section>

      <section className={styles.solutionSection}>
        <div className={styles.bannerContainer}>
          <div className={styles.bannerBox}>
            <div className={styles.fixedBanner}></div>
            <div className={styles.bannerText}>
              우리 매장에 딱 맞는 <br /> 맞춤형 결제 솔루션
            </div>
          </div>
        </div>

        <div className={styles.lightBlueBox}>
          <div className={[styles.maxWidth, styles.solutionContent].join(' ')}>
            <h1 data-aos='fade-up' className={styles.blackTitle}>
              다양한 맞춤서비스를 <br />
              제공해드려요
            </h1>

            <LazyLoadComponent>
              <div data-aos='fade-up' className={styles.solutionBox}>
                {solutions.map((solution, index) => {
                  return <SolutionItem key={index} solution={solution} />;
                })}
              </div>
            </LazyLoadComponent>
          </div>
        </div>
      </section>

      <section className={[styles.maxWidth, styles.connectSection].join(' ')}>
        <h1 data-aos='fade-up' className={styles.blackTitle}>
          유기적으로 연결되는 <br />
          결제솔루션을 만나보세요
        </h1>

        <div data-aos='fade-up' className={styles.connectContent}>
          <ConnectSlide />
        </div>
      </section>

      <section className={[styles.maxWidth, styles.qnaSection].join(' ')}>
        <h1 data-aos='fade-up' className={styles.blackTitle}>
          더 궁금한 점이 있나요?
        </h1>
        <div data-aos='fade-up'>
          <QnaList list={qnaList} />
        </div>
      </section>

      <section>
        <AskFooter />
      </section>

      <Footer />
      <TopButton isMain className={styles.topScroll} />

      {promoOpen && <PromoPopup setPromoOpen={setPromoOpen} />}
    </div>
  );
};

export default Main;
